import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus, HelpCircle } from 'lucide-react';
const faqs = [{
  question: '¿En qué formato recibo el material?',
  answer: 'Plataforma digital con PDF, videos y recursos descargables o consultables online. Puedes usarlo desde tu celular, tablet o computadora.'
}, {
  question: '¿El precio está en dólares?',
  answer: 'Sí. El precio está expresado en dólares estadounidenses. Al ingresar al checkout, la plataforma mostrará automáticamente la conversión a tu moneda local antes de finalizar la compra.'
}, {
  question: '¿Por cuánto tiempo tengo acceso?',
  answer: 'Tendrás acceso al material digital para consultarlo cuando lo necesites desde tu celular, tablet o computadora, según las condiciones indicadas al momento de la compra.'
}, {
  question: '¿Qué pasa si no me sirve el material?',
  answer: 'Cuentas con una garantía de satisfacción de 7 días. Si el material no es adecuado para tus necesidades, puedes solicitar la devolución dentro de ese plazo.'
}, {
  question: '¿Sirve para técnicos de toda Latinoamérica?',
  answer: 'Sí. El material está creado en español neutro y puede ser utilizado por estudiantes, técnicos, instaladores, personal de mantenimiento y personas que quieran aprender electricidad en distintos países de LATAM. Siempre se recomienda revisar la normativa eléctrica vigente de cada país o localidad.'
}, {
  question: '¿Cómo recibo el acceso?',
  answer: 'Una vez confirmado el pago, recibirás el acceso digital por correo electrónico con las instrucciones para ingresar al material.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 md:py-24 px-4 bg-white relative overflow-hidden" data-id="element-82">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-84">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-slate-100 text-navy rounded mb-6" data-id="element-85">
            <HelpCircle size={32} strokeWidth={2} data-id="element-86" />
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-navy" data-id="element-87">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-88">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-white rounded border transition-colors duration-300 ${openIndex === index ? 'border-navy shadow-md' : 'border-slate-200 shadow-sm hover:border-slate-300'}`} data-id="element-89">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full p-6 md:p-8 text-left flex justify-between items-center gap-6" data-id="element-90">
                <span className="font-black text-navy text-base md:text-xl leading-tight" data-id="element-91">
                  {faq.question}
                </span>
                <div className={`shrink-0 w-8 h-8 rounded flex items-center justify-center transition-colors ${openIndex === index ? 'bg-navy text-electric' : 'bg-slate-100 text-slate-500'}`} data-id="element-92">
                  {openIndex === index ? <Minus size={20} strokeWidth={2} data-id="element-93" /> : <Plus size={20} strokeWidth={2} data-id="element-94" />}
                </div>
              </button>
              <AnimatePresence data-id="element-95">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-96">
                    <div className="px-6 md:px-8 pb-8 pt-0 text-slate-600 font-medium text-sm md:text-lg leading-relaxed" data-id="element-97">
                      <div className="p-4 bg-slate-50 rounded border border-slate-100" data-id="element-98">
                        {faq.answer}
                      </div>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}